import React from 'react';
import { Typography } from '@mui/material';

// Host and student screens show the same "Question X of Y" label, just at
// different sizes (host reads it from across a room, student from a phone).
function QuestionCounter({ ord, count, fontSize }) {
    return (
        <Typography sx={{ mb: 1, fontWeight: 700, color: 'primary.main', fontSize }}>
            Question {ord + 1} of {count}
        </Typography>
    );
}

export default QuestionCounter;
